import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import NewReleases from "./components/NewReleases";
import TopRank from "./components/TopRank";
import CuratedLists from "./components/CuratedLists";
import Editorial from "./components/Editorial";
import GenreExplorer from "./components/GenreExplorer";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className={
        "fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-white shadow-soft transition-all duration-300 hover:bg-primary-700 md:bottom-8 md:right-8 " +
        (show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0")
      }
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </a>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <NewReleases />
        <TopRank />
        <CuratedLists />
        <Editorial />
        <GenreExplorer />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}